function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export function LocationIcon(_0) {
    let { color = '#53576C' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M15.0355 3.67294C13.7011 2.33853 11.8913 1.58887 10.0041 1.58887C8.11699 1.58887 6.30715 2.33853 4.97274 3.67294C3.63833 5.00734 2.88867 6.81719 2.88867 8.70433C2.88867 10.5915 3.63833 12.4013 4.97274 13.7357L9.39198 18.1633C9.46993 18.2419 9.56268 18.3043 9.66487 18.3469C9.76705 18.3895 9.87666 18.4114 9.98736 18.4114C10.0981 18.4114 10.2077 18.3895 10.3099 18.3469C10.412 18.3043 10.5048 18.2419 10.5827 18.1633L15.0355 13.6938C16.3644 12.3649 17.1109 10.5626 17.1109 8.68336C17.1109 6.80409 16.3644 5.00179 15.0355 3.67294ZM13.8364 12.4946L10.0041 16.3437L6.17189 12.4946C5.41479 11.7368 4.89935 10.7716 4.69073 9.72091C4.48211 8.67023 4.58968 7.58127 4.99983 6.59171C5.40999 5.60215 6.10432 4.7564 6.99505 4.16138C7.88578 3.56636 8.93293 3.24878 10.0041 3.24878C11.0753 3.24878 12.1225 3.56636 13.0132 4.16138C13.9039 4.7564 14.5983 5.60215 15.0084 6.59171C15.4186 7.58127 15.5262 8.67023 15.3175 9.72091C15.1089 10.7716 14.5935 11.7368 13.8364 12.4946ZM7.48844 6.12993C6.81148 6.80898 6.43134 7.72871 6.43134 8.68755C6.43134 9.6464 6.81148 10.5661 7.48844 11.2452C7.99137 11.749 8.63189 12.093 9.32963 12.2342C10.0274 12.3753 10.7513 12.3073 11.4105 12.0386C12.0697 11.7699 12.6349 11.3125 13.0351 10.7238C13.4354 10.1351 13.6528 9.44132 13.6603 8.72948C13.6641 8.25419 13.5725 7.78296 13.391 7.34366C13.2095 6.90436 12.9418 6.50591 12.6037 6.17186C12.2713 5.83189 11.875 5.561 11.4376 5.37478C11.0001 5.18855 10.5302 5.09068 10.0548 5.08678C9.57936 5.08288 9.10787 5.17304 8.66743 5.35207C8.227 5.5311 7.82631 5.79545 7.48844 6.12993ZM11.4213 10.0544C11.1035 10.377 10.6835 10.5793 10.2332 10.6265C9.78279 10.6738 9.32998 10.5631 8.95216 10.3135C8.57434 10.0638 8.29497 9.69068 8.16181 9.25785C8.02865 8.82502 8.04998 8.35937 8.22215 7.94052C8.39431 7.52167 8.70662 7.17564 9.10568 6.96157C9.50474 6.7475 9.96577 6.6787 10.4099 6.76692C10.8541 6.85514 11.2539 7.09492 11.5408 7.44525C11.8278 7.79558 11.9841 8.2347 11.9831 8.68755C11.9709 9.20518 11.7538 9.69679 11.3794 10.0544H11.4213Z",
            fill: color
        })
    }));
}
